import { useCallback } from "react";
import { useEntrypointContext } from "../infrastructure/entrypoint/EntrypointContext";
import { findURIAndReplaceOrigin } from "../infrastructure/entrypoint/link";
import { getPossibleUndefinedJSON } from "../infrastructure/api/digipost-fetch";
import { PersonMedFullmakter } from "../infrastructure/api/api";

export function useFinnRegistrertbartFraVerv() {
  const entrypoint = useEntrypointContext();

  const finnRegistrerbartFraVerv = useCallback(
    async (orgNr: string) => {
      const baseUri = findURIAndReplaceOrigin(
        "selskap-registrerbart",
        entrypoint._links,
      );

      const res = await getPossibleUndefinedJSON<PersonMedFullmakter>(
        baseUri + orgNr,
      );

      return res?.foretak.find(
        (foretak) => foretak.foretak.orgnummer === orgNr,
      );
    },
    [entrypoint._links],
  );

  return { finnRegistrerbartFraVerv };
}
